export function handleStateObjectChange<TObject>(
    stateObject: TObject,
    setStateObject: React.Dispatch<React.SetStateAction<TObject | undefined>>,
    name: keyof TObject,
    value: TObject[keyof TObject]
) {
    setStateObject({
        ...stateObject,
        [name]: value || null,
    });
}
